import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";

import {
  GET_TOPICS_V2_REFRESH_MAP,
  GET_TOPICS_V2_MAP_TOPIC,
} from "./actions.type";
import {
  SET_TOPICS_V2_REFRESH_MAP,
  SET_TOPICS_V2_MAP_TOPIC,
} from "./mutations.type";

import {
  getTopicsArray,
  getInfluencesArray,
} from "@/services/events/topics.service";

const refresh = new Date().toISOString();

// add the event topics to the main state object
const topics = {};

let TOPICS_ARRAY = null;
let INFLUENCES_ARRAY = null;

function init(params) {
  const rfh = params.refresh || refresh;
  TOPICS_ARRAY = lodashCloneDeep(getTopicsArray());
  TOPICS_ARRAY.map((topic) => {
    const field = topic.parentIds ? "apiName" : "type";
    const type = topic[field];
    topics[type] = {
      enabled: false,
      refresh: rfh,
    };
  });

  INFLUENCES_ARRAY = lodashCloneDeep(getInfluencesArray());
  INFLUENCES_ARRAY.map((topic) => {
    const type = topic.apiName;
    topics[type] = {
      enabled: false,
      refresh: rfh,
    };
  });
}

const STATE = {
  refreshMap: refresh,
  topics: topics,
};

const GETTERS = {
  refreshMap: (state) => state.refreshMap,
  topics: (state) => state.topics,
};

const ACTIONS = {
  async [GET_TOPICS_V2_REFRESH_MAP](context, params) {
    await context.commit(SET_TOPICS_V2_REFRESH_MAP, params);
  },
  async [GET_TOPICS_V2_MAP_TOPIC](context, params) {
    await context.commit(SET_TOPICS_V2_MAP_TOPIC, params);
  },
};

const MUTATIONS = {
  [SET_TOPICS_V2_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
  [SET_TOPICS_V2_MAP_TOPIC](state, data) {
    if (!lodashGet(state, `topics[${data.type}]`)) {
      init(data);
    }
    if (state.topics[data.type]) {
      state.topics[data.type].enabled = data.enabled;
      state.topics[data.type].refresh = data.refresh;
    }
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
